import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormViewSet } from '@cer/cer-form/cer-form-view-set';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from '@cer/cer-data/cer-data-types';

export class WarehouseCarrierForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {

    //viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 40);
    const view = new CerFormView({
      viewMetadata: {
        name: 'transport', dataApiName: 'WarehouseCarrier', text: 'Transportører', textSingular: 'Transportør',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
      },
      fieldMetadata: []
    });
    viewSet.viewAdd(view);

    const viewServicePoints = new CerFormView({
      viewMetadata: {
        name: 'transport-pakke-shops', dataApiName: 'WarehouseCarrierServicePoint', text: 'Pakkeshops', textSingular: 'Pakkeshop',
        primaryKey: 'id', parentPrimaryKey: 'num', parentForeignKey: 'keyType',
        baseFields: ['id'], titleFields: ['num', 'product', 'name']
      },
      fieldMetadata: [
        { name: 'keyCountry', text: 'Land', required: true, foreignKeyTableName: 'Country', foreignKeyField: 'iso2', widthType: FieldWidthEnum.S },
        { name: 'keyType', text: 'Transportør', required: true, foreignKeyTableName: 'WarehouseCarrier', foreignKeyField: 'num', widthType: FieldWidthEnum.S, visible: false },
        { name: 'key', text: 'Pakkeshop nr.', tooltipText: 'Pakkenshoppens id', required: true, widthType: FieldWidthEnum.S },
        { name: 'name', text: 'Navn', widthType: FieldWidthEnum.M },
        { name: 'address1', text: 'Adresse 1', widthType: FieldWidthEnum.M },
        { name: 'address2', text: 'Adresse 2', widthType: FieldWidthEnum.M },
        { name: 'postalCode', text: 'Postnr', widthType: FieldWidthEnum.S },
        { name: 'postalDistrict', text: 'By', widthType: FieldWidthEnum.M },
        { name: 'phone', text: 'Telefon', widthType: FieldWidthEnum.M }
      ]
    });
    viewServicePoints.paneTarget = 'main';
    viewSet.viewAdd(viewServicePoints, view);
  }
}
